import { render, staticRenderFns } from "./ProjectViewContacts.vue?vue&type=template&id=6fd4c3b3&"
import script from "./ProjectViewContacts.vue?vue&type=script&lang=js&"
export * from "./ProjectViewContacts.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports